import { render, staticRenderFns } from "./staticForm.vue?vue&type=template&id=6bf254ed&scoped=true&"
import script from "./staticForm.vue?vue&type=script&lang=js&"
export * from "./staticForm.vue?vue&type=script&lang=js&"
import style0 from "./staticForm.vue?vue&type=style&index=0&id=6bf254ed&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bf254ed",
  null
  
)

export default component.exports